const BUILD_KEY_PATTERN =
	/^(?:canary-)?(?:CLASSIC-master-(\d+)|CLASSIC-confluence-hotfix-(\d+)-(\d+))$/;

export const buildKeyToSemVerString = (buildKey: string | undefined): string | undefined => {
	if (process.env.PILLAR_LOCAL_DEVELOPMENT) {
		return undefined;
	}

	if (!buildKey) {
		throw new Error('Missing build key, build key is required for sticky versions');
	}

	const match = BUILD_KEY_PATTERN.exec(buildKey);
	const [, masterMinor, hotfixMinor, patch] = match ?? [];

	const minorVersion = masterMinor ?? hotfixMinor;
	if (!minorVersion) {
		throw new Error(`${buildKey} is not a valid version for sticky versions`);
	}
	const patchVersion = hotfixMinor ? patch : '0';

	return `0.${minorVersion}.${patchVersion}`;
};
